{
  "login.instructions_title": "Authorize the CLI to access your Wix account:",
  "login.instructions_details": "1. Copy this code to the clipboard: <0>{code}</0>\n2. Choose an option:",
  "login.have_wix_account": "Already have an account? Press <0/> to <1>log in</1> and then paste the code",
  "login.new_to_wix": "New to Wix? Press <0/> to <1>sign up</1> and then paste the code",
  "login.legacy_auth_notice": "We implemented a new and more secure login method. You'll need to re-login to continue using the CLI.",
  "login.error_opening_browser": "Failed to open browser, please try opening <0/> manually."
}
